import BaseModelInstance from './base.model'
import { StripeCustomer as ModelDefinition } from './model-definitions'

class StripeCustomer extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default StripeCustomer
